// getLoginData.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

/**
 * Select login data by data key
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} dataKey - data key.
 * @return {any} The selected login data.
 */
const getLoginData = createCachedSelector(
  state => state.getIn(['operations', 'login']),
  (state, dataKey) => dataKey,
  (login, dataKey) => {
    let result = login?.get(dataKey);
    if ('emailDidYouMean' === dataKey) {
      const email = login.get('email');
      result = login.getIn(['emailOtp', email, 'didYouMean']);
    } else if ('isEmailSuggested' === dataKey) {
      const email = login.get('email');
      const emailDidYouMean = login.getIn(['emailOtp', email, 'didYouMean']);
      result = email === emailDidYouMean;
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)((state, dataKey) => dataKey);

export default getLoginData;
